exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thresholdText[data-v-50e4640c] {\n  width: 100px;\n  margin-left: 10px;\n  background: #fafafa;\n  text-align: center;\n  border-radius: 6px;\n}\n", ""]);

// exports
